import {Component, Input, OnInit} from '@angular/core';
import {AppBaseComponent} from "@utils";
import {ControlContainer} from "@angular/forms";
import {zip} from "rxjs";

import Swal from 'sweetalert2';

import {FileService, MessageService, ProcedureService, MasterService} from '@services';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: [ './attachments.component.scss' ]
})
export class AttachmentsComponent extends AppBaseComponent implements OnInit {


  @Input() isPersonaJuridica: boolean = false;

  //forms
  public attachmentForm;//: FormGroup

  programTypes: any[] = [];
  titleTypes: any[] = [];
  typeProfessional: any[] = [];
  public listFiles: any[] = [];

  public listDocuments;

  public isTecnico: boolean = false;
  public isTecnologo: boolean = false;
  public isProfesional: boolean = false;
  public isDoctorado: boolean = false;

  public textPregrado: string = "";

  constructor(private procedureService: ProcedureService,
              private fileService: FileService,
              private popupAlert: MessageService,
              private controlContainer: ControlContainer,
              private masterService: MasterService) {
    super();
  }

  ngOnInit(): void {
    this.attachmentForm = this.controlContainer.control;
    this.attachmentForm = this.attachmentForm.controls['attachmentForm'];

    this.getListaDocumentosASubir();
    this.getListsSelects();
  }


  checkSelectedFile(event: any, docTypeId: number, forPregrado?: string): void {
    let archivos = event.target.files;
    if (archivos.length > 1) {
      this.popupAlert.errorAlert('Solo puedes agregar un archivo', 3000);
      archivos = '';
      (<HTMLInputElement>document.getElementById(`inputDocument_${docTypeId}`)).value = '';
      return;
    }

    const fileSelected = archivos[0];
    if (fileSelected && fileSelected.type != "application/pdf") {
      (<HTMLInputElement>document.getElementById(`inputDocument_${docTypeId}`)).value = '';
      Swal.fire({
          icon: "error",
          title: 'Formato no valido',
          text: 'Solo se admiten documentos en formato PDF',
          showCloseButton: true,
          confirmButtonColor: '#3085d6',
        }
      ).then((result) => {
        archivos = null;
      });
      return;
    }


    const idx = this.listFiles.findIndex(_file => _file.docTypeId == docTypeId);
    if (idx == -1) {
      this.listFiles.push({ docTypeId, contenido: fileSelected });
      this.fileService.setFilesAdded(this.listFiles);
    } else {
      if (fileSelected) {
        this.listFiles[idx] = { docTypeId, contenido: fileSelected };
      } else {
        this.listFiles.splice(idx, 1);
      }
      this.fileService.setFilesAdded(this.listFiles);
    }
  }

  public getErrorMessage(field: string): string {
    let message;

    const required: Array<string> = ['programTypeId', 'titleTypeId', 'typeProfessionalId', 'titleProfessionalName', 'titleDoctorateName', 'otherProfessionalName', 'entityAddress'];
    const min5Charts: Array<string> = ['titleProfessionalName', 'titleDoctorateName', 'otherProfessionalName', 'entityAddress'];

    if (this.isTouchedField(this.attachmentForm, field)) {
      if (required.includes(field) && this.attachmentForm?.get(field).hasError('required') ) {
        message = "Es requerido";
      } else if (min5Charts.includes(field) && this.attachmentForm?.get(field).hasError('minlength')) {
        message = "Debe tener al menos 5 caracteres";
      }
    }
    return message;
  }

  hasDocument(docTypeId: number) {
    return this.listFiles.find(_file => _file.docTypeId == docTypeId);
  }

  removeFileAdded(docTypeId: number) {
    const idx = this.listFiles.findIndex(_file => _file.docTypeId == docTypeId);
    if (idx != -1) {
      (<HTMLInputElement>document.getElementById(`inputDocument_${docTypeId}`)).value = '';
      this.listFiles.splice(idx, 1);
      this.fileService.setFilesAdded(this.listFiles);
    }
  }

  public getListaDocumentosASubir() {
    let data = {
      "programTypeId": this.attachmentForm.controls['programTypeId'].value,
      "titleTypeId": this.attachmentForm.controls['titleTypeId'].value,
      "personTypeId": this.isPersonaJuridica ? 2 : 1
    };

    this.masterService.getDocumentTypes(data).subscribe(resp => {
      this.listDocuments = resp;
      this.attachmentForm.get('quantityDocuments').setValue(this.listDocuments.length);
      this.listDocuments.forEach(document => this.removeFileAdded(document.id));
    });
  }

  /**
   * Carga las listas de los desplegables
   */
  private getListsSelects(): void {
    zip(
      this.masterService.getProgramTypes(),
      this.masterService.getTitleTypes(),
      this.masterService.getTypeProfessional()
    ).subscribe(resp => {
      this.programTypes = resp[0];
      this.titleTypes = resp[1];
      this.typeProfessional = resp[2];
    })
  }
}
